'use client'

import { PORTAL_ONBOARDING_LAYOUT } from '@common/apps/portal-onboarding/portal-onboarding.const'

import type { PortalOnboardingTargetRect } from '@apps/portal-onboarding/portal-onboarding.interface'
import { PORTAL_ONBOARDING_TEST_IDS } from '@apps/portal-onboarding/portal-onboarding-test-ids.const'

import styles from './PortalTutorial.module.scss'

type PortalOnboardingOverlayProps = {
  targetRect: PortalOnboardingTargetRect | null
  showHighlight: boolean
}

export function PortalOnboardingOverlay({ targetRect, showHighlight }: PortalOnboardingOverlayProps) {
  if (!showHighlight || !targetRect) {
    return <div className={styles.overlayPanel} style={{ inset: 0 }} data-testid={PORTAL_ONBOARDING_TEST_IDS.overlay} />
  }

  const { highlightPadding } = PORTAL_ONBOARDING_LAYOUT
  const top = Math.max(0, targetRect.top - highlightPadding)
  const left = Math.max(0, targetRect.left - highlightPadding)
  const width = targetRect.width + highlightPadding * 2
  const height = targetRect.height + highlightPadding * 2
  const viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 0
  const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 0

  return (
    <div className={styles.overlayPanels} data-testid={PORTAL_ONBOARDING_TEST_IDS.overlay}>
      <div className={styles.overlayPanel} style={{ top: 0, left: 0, right: 0, height: top }} />
      <div className={styles.overlayPanel} style={{ top, left: 0, width: left, height }} />
      <div className={styles.overlayPanel} style={{ top, left: left + width, right: 0, height }} />
      <div className={styles.overlayPanel} style={{ top: top + height, left: 0, right: 0, bottom: 0 }} />
      <div
        className={styles.highlight}
        style={{
          top,
          left,
          width: Math.min(width, viewportWidth - left),
          height: Math.min(height, viewportHeight - top),
        }}
      />
    </div>
  )
}
